import { useDojo } from "@/plugins/vibeDojo/dojoAudio";
import { Sprout, Volume2, Headphones } from "lucide-react";

// Compact Dojo controls for the (dark) course/video player so ambient audio can
// be toggled and tuned live — including the ducking level applied during playback.
export function DojoControls() {
  const { enabled, toggle, volume, setVolume, duckLevel, setDuckLevel } = useDojo();
  return (
    <div className="border border-white/10 bg-white/5 p-4" data-testid="player-dojo-controls">
      <div className="flex items-center justify-between mb-3">
        <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-emerald-300">
          <Sprout className="h-3.5 w-3.5" /> Dojo Mode
        </span>
        <button
          onClick={toggle}
          data-testid="player-dojo-toggle"
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${enabled ? "bg-emerald-500" : "bg-white/20"}`}
          aria-pressed={enabled} aria-label="Toggle Dojo Mode"
        >
          <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${enabled ? "translate-x-5" : "translate-x-0.5"}`} />
        </button>
      </div>
      <div className={`space-y-3 transition-opacity ${enabled ? "opacity-100" : "opacity-40 pointer-events-none"}`}>
        <div>
          <div className="flex items-center justify-between text-[11px] text-white/60 mb-1">
            <span className="inline-flex items-center gap-1.5"><Volume2 className="h-3.5 w-3.5" /> Ambient volume</span>
            <span className="font-mono text-emerald-300">{Math.round(volume * 100)}%</span>
          </div>
          <input type="range" min="0" max="1" step="0.05" value={volume}
            onChange={(e) => setVolume(parseFloat(e.target.value))}
            className="w-full h-1 accent-emerald-500 cursor-pointer" data-testid="player-dojo-volume" aria-label="Dojo ambient volume" />
        </div>
        <div>
          <div className="flex items-center justify-between text-[11px] text-white/60 mb-1">
            <span className="inline-flex items-center gap-1.5"><Headphones className="h-3.5 w-3.5" /> Duck during playback</span>
            <span className="font-mono text-emerald-300">{Math.round(duckLevel * 100)}%</span>
          </div>
          <input type="range" min="0" max="1" step="0.05" value={duckLevel}
            onChange={(e) => setDuckLevel(parseFloat(e.target.value))}
            className="w-full h-1 accent-emerald-500 cursor-pointer" data-testid="player-dojo-duck" aria-label="Dojo ducking level during playback" />
          <p className="text-[10px] text-white/40 mt-1">Ambient drops to this % of your volume while narration plays.</p>
        </div>
      </div>
    </div>
  );
}
